import { render, staticRenderFns } from "./highlitghtsSection.vue?vue&type=template&id=885cebe2"
import script from "./highlitghtsSection.vue?vue&type=script&lang=js"
export * from "./highlitghtsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports